var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { getIdentityVerificationRequest, hasIdentityVerificationRequest, hasRecasedSSPRequest, hasNeededSSPRequest } from '@banking/ui/utils/risk-utils';
import { open } from '@square/dashboard-utilities/utils/window';
var CDPEvent = /*#__PURE__*/function (CDPEvent) {
  CDPEvent["BannerViewed"] = "unit_message_unit_viewed";
  CDPEvent["BannerClicked"] = "unit_message_unit_clicked";
  return CDPEvent;
}(CDPEvent || {});
var RiskMessageType = /*#__PURE__*/function (RiskMessageType) {
  RiskMessageType["IdentityVerification"] = "IdentityVerification";
  RiskMessageType["SSP"] = "SSP";
  RiskMessageType["SSPRecased"] = "SSPRecased";
  return RiskMessageType;
}(RiskMessageType || {});
let VerificationBannersService = (_class = class VerificationBannersService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "dataApi", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
  }
  getBanners(goToBusinessInformation, riskProfileUnits, isFrozen) {
    const banners = [];
    if (this.showVeriffBanner(riskProfileUnits)) {
      banners.push(this.createVeriffBanner(riskProfileUnits));
      this.trackIdentityVerification(CDPEvent.BannerViewed, riskProfileUnits);
    } else if (this.showPendingSSPBanner(riskProfileUnits)) {
      banners.push(this.createPendingSSPBanner(goToBusinessInformation, riskProfileUnits));
      this.trackSSP(CDPEvent.BannerViewed, riskProfileUnits);
    } else if (this.showRecasedSSPBanner(riskProfileUnits)) {
      banners.push(this.createRecasedSSPBanner(goToBusinessInformation, riskProfileUnits));
      this.trackRecasedSSP(CDPEvent.BannerViewed, riskProfileUnits);
    } else if (isFrozen) {
      banners.push(this.createFrozenBanner());
    }
    return banners;
  }
  showVeriffBanner(riskProfileUnits) {
    return riskProfileUnits?.some(unit => hasIdentityVerificationRequest(unit)) ?? false;
  }
  showPendingSSPBanner(riskProfileUnits) {
    return riskProfileUnits?.some(unit => hasNeededSSPRequest(unit)) ?? false;
  }
  showRecasedSSPBanner(riskProfileUnits) {
    return riskProfileUnits?.some(unit => hasRecasedSSPRequest(unit)) ?? false;
  }
  createVeriffBanner(riskProfileUnits) {
    return {
      key: 'veriff-banner',
      variant: 'critical',
      title: this.intl.t('banking.launchpad.verificationBanner.docidv.title'),
      description: this.intl.t('banking.launchpad.verificationBanner.docidv.description'),
      actions: [{
        elementType: 'button',
        text: this.intl.t('banking.launchpad.verificationBanner.docidv.cta'),
        onClick: () => this.openVeriff(riskProfileUnits)
      }]
    };
  }
  createPendingSSPBanner(goToBusinessInformation, riskProfileUnits) {
    return {
      key: 'ssp-banner',
      variant: 'critical',
      title: this.intl.t('banking.launchpad.verificationBanner.ssp.title'),
      description: this.intl.t('banking.launchpad.verificationBanner.ssp.description'),
      actions: [{
        elementType: 'button',
        text: this.intl.t('banking.launchpad.verificationBanner.ssp.cta'),
        onClick: () => this.openPendingSSP(goToBusinessInformation, riskProfileUnits)
      }]
    };
  }
  createRecasedSSPBanner(goToBusinessInformation, riskProfileUnits) {
    return {
      key: 'ssp-recased-banner',
      variant: 'critical',
      title: this.intl.t('banking.launchpad.verificationBanner.recased.title'),
      description: this.intl.t('banking.launchpad.verificationBanner.recased.description'),
      actions: [{
        elementType: 'button',
        text: this.intl.t('banking.launchpad.verificationBanner.recased.cta'),
        onClick: () => this.openRecasedSSP(goToBusinessInformation, riskProfileUnits)
      }]
    };
  }
  createFrozenBanner() {
    return {
      key: 'frozen-banner',
      variant: 'warning',
      description: this.intl.t('banking.launchpad.verificationBanner.isFrozen.description')
    };
  }
  openVeriff(riskProfileUnits) {
    const riskProfileUnit = riskProfileUnits?.find(unit => hasIdentityVerificationRequest(unit));
    if (riskProfileUnit) {
      const verificationRequest = getIdentityVerificationRequest(riskProfileUnit);
      if (verificationRequest?.userFormUrl) {
        this.trackIdentityVerification(CDPEvent.BannerClicked, riskProfileUnits);
        open(verificationRequest.userFormUrl, '_blank');
      }
    }
  }
  openPendingSSP(goToBusinessInformation, riskProfileUnits) {
    this.trackSSP(CDPEvent.BannerClicked, riskProfileUnits);
    goToBusinessInformation();
  }
  openRecasedSSP(goToBusinessInformation, riskProfileUnits) {
    this.trackRecasedSSP(CDPEvent.BannerClicked, riskProfileUnits);
    goToBusinessInformation();
  }
  trackVerificationEvent(event, riskMessageType, riskProfileUnit) {
    this.dataApi.track(event, {
      riskMessageType,
      unitToken: riskProfileUnit.unitToken,
      merchantToken: riskProfileUnit.merchantToken
    });
  }
  trackSSP(event, riskProfileUnits) {
    const riskProfileUnit = riskProfileUnits?.find(unit => hasNeededSSPRequest(unit));
    if (riskProfileUnit) {
      this.trackVerificationEvent(event, RiskMessageType.SSP, riskProfileUnit);
    }
  }
  trackRecasedSSP(event, riskProfileUnits) {
    const riskProfileUnit = riskProfileUnits?.find(unit => hasRecasedSSPRequest(unit));
    if (riskProfileUnit) {
      this.trackVerificationEvent(event, RiskMessageType.SSPRecased, riskProfileUnit);
    }
  }
  trackIdentityVerification(event, riskProfileUnits) {
    const riskProfileUnit = riskProfileUnits?.find(unit => hasIdentityVerificationRequest(unit));
    if (riskProfileUnit) {
      this.trackVerificationEvent(event, RiskMessageType.IdentityVerification, riskProfileUnit);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { VerificationBannersService as default };